define('v3/Common/Helpers/Pdf/Pdf.Helper',[
	'knockout',
	'jquery',
	'lodash',
	'moment',
	'env',
	'v3/Common/Services/frontend/Frontend.Service',
	'canvgModule',
	'html2canvas',
	'jspdf',
	'promise-polyfill'
], function (ko, $, _, moment, env, frontend, canvg, html2canvas, JsPDF) {
	var pdf;
	var options = {
		debug: true,
		$sprite: null,
		container: {
			selector: '.printable-page',
			$clone: null
		},
		classes: {
			clone: 'printable-page printable-page-clone',
			html: 'showPrintPage'
		},
		margins: {
			item: 30,
			page: {
				top: 50,
				bottom: 50
			}
		},
		dimensions: {
			a4: {
				width: 595.28,
				height: 841.89
			}
		},
		html2canvas: {
			allowTaint: true
		}
	};
	options.html2canvas.logging = options.debug;

	var log = (options.debug) ? function (title, elm) {
		console.log(title);
		if (elm) {
			console.dir(elm);
		}
	} : _.noop;

	function PdfHelper () {};

	PdfHelper.prototype.generate = function (sections) {
		var self = this;

		if (!sections) {
			throw new Error('No options defined.');
		}
		if (!sections.fileName) {
			throw new Error('No options.fileName defined.');
		}
		if (!sections.sections) {
			throw new Error('No options.sections defined.');
		}

		options.container.$clone = $(options.container.selector)
			.clone()
			.attr('class', options.classes.clone)
			.appendTo('body');

		options.sections = _.extend([], sections.sections);
		options.fileName = sections.fileName;
		options.progressText = sections.progressText || ko.observable('');
		options.container.selector = sections.container || options.container.selector;

		if ($(options.container.selector).length === 0) {
			throw new Error('The element ' + options.container.selector + ' was not found within the DOM.');
		}

		frontend.mask.show($('body'), { title: options.progressText });
		$('html').addClass(options.classes.html);
		options.progressText(Strings.PdfLoadingStep1);

		setTimeout(function () {
			log('Converting images...');
			self.images.convert().then(function () {
				log('Get sections...');
				self.sections.get().then(function () {
					log('Format sections');
					var output = self.sections.format();
					log('Generating PDF...');
					self.generate.PDF(output).then(function (pdf) {
						pdf.save(options.fileName + '.pdf');
						frontend.mask.hide($('body'));

						pdf = null;
						options.container.$clone.remove();
					});
				});
			});
		}, 100);
	};

	PdfHelper.prototype.images = {
		convert: function () {
			var self = this;
			var promise = $.Deferred();
			var $svgs = options.container.$clone.find('svg, img[src$=".svg"]');
			var onSpriteLoad = function (svgSprite) {
				options.$sprite = options.$sprite || $(svgSprite);

				if ($svgs.length > 0) {
					$svgs.each(function (i, svg) {
						var $svg = $(svg);
						var onEnd = function () {
							if (i === ($svgs.length - 1)) {
								promise.resolve();
								$svg = null;
							}
						};

						if (!$svg.is(':hidden') && $svg.css('display') !== 'none') {
							if ($svg.find('use').length > 0) {
								self.use(options.$sprite, $svg.find('use'), onEnd);
							} else if ($svg.is('img')) {
								self.img($svg, onEnd);
							} else {
								self.svg($svg, onEnd);
							}
						} else {
							onEnd();
						}
					});
				} else {
					setTimeout(function () {
						promise.resolve();
					}, 10);
				}
			};

			if ($svgs.length > 0) {
				if (!options.$sprite) {
					$.get(env.paths.svgSprite).always(onSpriteLoad);
				} else {
					onSpriteLoad();
				}
			} else {
				setTimeout(function () {
					promise.resolve();
				}, 10);
			}

			return promise;
		},
		use: function (sprite, use, callback) {
			var id = $(use).attr('href').split('#')[1];

			if (id) {
				var element = sprite.find('#' + id);
				var parent = $(use).parent();

				var width = parent.width();
				var height = parent.height();
				var fill = parent.css('fill');
				var contents = element.html();

				var icon = document.createElement('canvas');
				icon.setAttribute('width', width);
				icon.setAttribute('height', height);

				log('Convert SVG with fragement indetifiers "' + id + '" to PNG.');
				canvg(icon, '<svg viewBox="0 0 32 32" style="fill: ' + fill + ';">' + contents + '</svg>', {
					renderCallback: function () {
						var img = $('<img>')
							.attr('src', icon.toDataURL('image/png'))
							.attr('style', parent.attr('style'))
							.attr('class', parent.attr('class'));

						parent.replaceWith(img);
						icon = null;
						parent = null;
						callback();
					}
				});
			} else {
				callback();
			}
		},
		svg: function ($svg, callback) {
			var parent = $svg;
			var width = $svg.width();
			var height = $svg.height();
			var fill = parent.css('fill');

			var image = document.createElement('canvas');
			image.setAttribute('width', width);
			image.setAttribute('height', height);

			var tmp = $('<div>').append($svg.clone().attr('fill', fill)).html();
			log('Convert SVG to PNG.');
			canvg(image, tmp, {
				renderCallback: function () {
					var img = $('<img>')
						.attr('src', image.toDataURL('image/png'))
						.attr('style', parent.attr('style'))
						.attr('class', parent.attr('class'));

					parent.replaceWith(img);
					image = null;
					tmp = null;
					parent = null;
					callback();
				}
			});
			callback();
		},
		img: function ($img, callback) {
			var width = $img.width();
			var height = $img.height();

			var image = document.createElement('canvas');
			image.setAttribute('width', width);
			image.setAttribute('height', height);

			log('Convert IMG with SVG "' + $img.attr('src') + '" to PNG.');
			if ($img.get(0)) {
				canvg(image, $img.attr('src'), {
					renderCallback: function () {
						var img = $('<img>')
							.attr('src', image.toDataURL('image/png'))
							.attr('style', $img.attr('style'))
							.attr('class', $img.attr('class'));

						$img.replaceWith(img);
						image = null;
						callback();
					}
				});
			} else {
				callback();
			}
		}
	};

	PdfHelper.prototype.sections = {
		get: function () {
			var promise = $.Deferred();
			var $container = options.container.$clone;
			var progress = 0;
			var onEnd = function () {
				progress++;
				if (options.sections.length === progress) {
					promise.resolve();
				}
			};

			_.each(options.sections, function (section) {
				if (section.element) {
					$container.find(section.element).css('fontFeatureSettings', '"liga" 0'); // fix ligature: fi, ff
					html2canvas($container.find(section.element).get(0), options.html2canvas)
						.then(function (canvas) {
							section.canvas = canvas;
							section.$elm = $container.find(section.element);
							onEnd();
						});
				} else if (section.elements) {
					var progressCache = 0;
					var tmp = _.map(section.elements, function (elm) {
						var $find = $container.find(elm) || [false];

						return _.map($find, function (elm) {
							if (!elm || !$(elm).is(':visible')) {
								if (options.container.$clone.find('.emptyPdfSection').length === 0) {
									return $('<div />')
										.addClass('emptyPdfSection')
										.appendTo(options.container.$clone)
										.get(0);
								} else {
									return options.container.$clone.find('.emptyPdfSection').get(0);
								}
							} else {
								return elm;
							}
						});
					});
					var cacheSize = _.flattenDeep(tmp);
					var cache = _.unzip(tmp);

					section.canvas = [];
					section.$elm = [];
					_.each(cache, function (subsection, idx) {
						section.canvas[idx] = section.canvas[idx] || [];
						section.$elm[idx] = section.$elm[idx] || [];

						_.each(subsection, function (element, index) {
							$(element).css('fontFeatureSettings', '"liga" 0'); // fix ligature: fi, ff
							html2canvas(element, options.html2canvas)
								.then(function (canvas) {
									section.canvas[idx][index] = canvas;
									section.$elm[idx][index] = element;

									progressCache++;
									if (cacheSize.length === progressCache) {
										onEnd();
									}
								});
						});
					});
				}
			});

			return promise;
		},
		format: function () {
			var hasLoop = _.filter(options.sections, { loop: true });
			var output = [];

			if (hasLoop.length > 0) {
				_.each(hasLoop, function (item) {
					for (var i = 0; i < item.canvas.length; i++) {
						_.each(options.sections, function (section) {
							if (!section.elements && (!section.isRendered || section.repeat)) {
								section.isRendered = true;
								output.push(section);
							}
							if (section.elements) {
								output.push({
									canvas: item.canvas[i],
									$elm: item.$elm[i]
								});
							}
						});
					}
				});
			} else {
				output = options.sections;
			}

			return output;
		}
	};

	PdfHelper.prototype.generate.PDF = function (sections) {
		var promise = $.Deferred();
		var position = 0;
		var margin = options.margins;
		var a4 = {
			width: options.dimensions.a4.width,
			height: options.dimensions.a4.height - margin.page.bottom
		};

		log('Setup A4 dimensions', a4);
		log('Setup margins', margin);

		pdf = new JsPDF('p', 'pt', 'a4', {
			useCors: true
		});

		var addMask = function (pos, height) {
			pdf.setFillColor(255, 255, 255);
			pdf.rect(0, pos, a4.width, height, 'F');
		};
		var checkRemainingHeight = function (canvas, section, isRetry) {
			var imgWidth = a4.width;
			var imgHeight = a4.width / canvas.width * canvas.height;
			var elmMargin = parseFloat(section.$elm.css('margin-bottom'));

			if ((position + imgHeight) > a4.height) {
				log('PDF: Section doesn\'t fit the page', canvas);

				if (section.pageBreak === 'avoid' && !isRetry) {
					position = margin.item;

					log('Add new page');
					pdf.addPage();

					checkRemainingHeight(canvas, section, true);
				} else {
					var totalPages = Math.floor((position + imgHeight) / a4.height);
					for (var i = 0; i <= totalPages; i++) {
						if (totalPages === i) {
							pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, position, imgWidth, imgHeight);
							position += imgHeight + elmMargin;

							log('Mask undershot');
							addMask(0, margin.page.top);
						} else {
							var overshoot = (position + imgHeight) - a4.height;

							if (i !== 0) {
								log('Mask undershot');
								addMask(0, margin.page.top);
							}

							log('PDF section page overshoot: ', overshoot);
							pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, position, imgWidth, imgHeight);

							log('Mask overshot');
							addMask(a4.height, margin.page.bottom);

							log('Add new page');
							pdf.addPage();

							position = -(imgHeight - overshoot) + margin.page.top;
						}
					}
				}
			} else {
				log('PDF: Section does fit the page', canvas);
				pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, position, imgWidth, imgHeight);

				position += imgHeight + elmMargin;
			}
		};

		_.each(sections, function (section, i) {
			options.progressText(Strings.PdfLoadingStep2);

			if (i !== 0 && section.pageBreak === 'always') {
				log('Generating new PDF page:');
				pdf.addPage();
				position = 0;
			}

			if (_.isArray(section.canvas)) {
				_.each(section.canvas, function (canvas, idx) {
					checkRemainingHeight(canvas, { $elm: $(section.$elm[idx]) });
				});
			} else {
				checkRemainingHeight(section.canvas, section);
			}
		});

		addMask(a4.height, margin.page.bottom);

		setTimeout(function () {
			promise.resolve(pdf);
		}, 10);

		return promise;
	};

	return PdfHelper;
});
